module.exports = __webpack_public_path__ + "h5/img/PDF3.64e0ed0f.jpg";